/**
 * UI density scale is applied via document.body.style.zoom (see osStore.applyUiScale).
 * MouseEvent clientX/Y and getBoundingClientRect report unscaled CSS pixels.
 * position:fixed under body uses zoomed layout coords - divide by zoom when placing.
 */
export function effectiveUiZoom(): number {
  try {
    const z = String((document.body as HTMLElement).style.zoom || "").trim();
    if (z) {
      const n = Number(z);
      if (Number.isFinite(n) && n > 0.2 && n < 3) return n;
    }
    const cs = getComputedStyle(document.documentElement)
      .getPropertyValue("--os-ui-scale")
      .trim();
    const n2 = Number(cs);
    if (Number.isFinite(n2) && n2 > 0.2 && n2 < 3) return n2;
  } catch {
    /* */
  }
  return 1;
}

export function clientToLayout(x: number, y: number): { x: number; y: number } {
  const s = effectiveUiZoom();
  return { x: x / s, y: y / s };
}
